
/* eslint-disable dot-notation */
import { defineComponent, nextTick, onMounted, computed } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCN from 'element-plus/lib/locale/lang/zh-cn'
import zhTW from 'element-plus/lib/locale/lang/zh-tw'
import en from 'element-plus/lib/locale/lang/en'
import ja from 'element-plus/lib/locale/lang/ja'
import { useI18n } from 'vue-i18n'
import '@/assets/iconofnt/iconfont.css'
import { HIDE_FUNC } from '@/common/const/hide-function-config'
import { useBrandCustomStore } from '@/services/brand-custom.service'
import { vncDeviceStore, sshDeviceStore } from '@/services/remote-device.service'
import CaptchaDialog from '@/views/_components/captcha-dialog/captcha-dialog.vue'
import DevDebug from '@/views/dashboard/_components/central-control/_components/dev-debug/dev-debug.vue'
import { IS_PRODUCTION } from '@/common/const/env'
import { handleFrom } from '@/app'

export default defineComponent({
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    CaptchaDialog,
    DevDebug,
  },
  setup () {
    function triggerScrollBarVisible (node: HTMLElement) {
      const attribute = 'cm_scrollbar_show'
      clearTimeout(node['__scroll_timer__'])

      node['__scroll_timer__'] = setTimeout(() => {
        node.removeAttribute && node.removeAttribute(attribute)
        node['__scroll_timer__'] = null
      }, 1000)

      node.setAttribute && node.setAttribute(attribute, '')
    }

    function isScroller (node: HTMLElement) {
      const getOverflow = (attributes) => {
        return window.getComputedStyle(node).getPropertyValue(attributes)
      }
      const scrollStyles = ['auto']
      return scrollStyles.includes(getOverflow('overflow')) ||
        scrollStyles.includes(getOverflow('overflow-x')) ||
        scrollStyles.includes(getOverflow('overflow-y'))
    }

    function initScrollbar () {
      document.addEventListener('scroll', function ($event) {
        const node = $event.target as HTMLElement
        triggerScrollBarVisible(node)
      }, true)

      document.addEventListener('mousemove', function ($event) {
        let node = $event.target as HTMLElement
        while (node?.parentElement && !isScroller(node)) {
          node = node.parentElement
        }

        triggerScrollBarVisible(node)
      }, true)
    }

    onMounted(() => {
      nextTick(() => {
        initScrollbar()
      })
    })

    useBrandCustomStore().initBrandCustom()
    vncDeviceStore.watchUnload()
    sshDeviceStore.watchUnload()
    handleFrom()

    const { locale: localeKey } = useI18n()
    const locale = computed(() => {
      switch (localeKey.value) {
        case 'zh-CN': return zhCN
        case 'zh-TW': return zhTW
        case 'ja-JP': return ja
        default: return en
      }
    })

    return {
      locale,
      IS_PRODUCTION,
    }
  }
})
